<script lang="ts">
	import { LabelList } from '@Shelly/shelly-design-system/index';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Types
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let statuses: VCInterfaceStatus[];
	export let templateRoles: string[];
</script>

{#if $showNewLayout}
	<DeviceLabelList labelList={statuses.filter((i) => templateRoles.includes(i.role))} />
{:else}
	<LabelList
		class="mb-l justify-content-center"
		size="m"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
		labelList={statuses.filter((i) => templateRoles.includes(i.role))}
		on:label-click={(e) => {
			e.stopPropagation();
		}}
	/>
{/if}
